module.exports = __webpack_public_path__ + "img/15_Sigmoid Colon.c0271464.png";